import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    inject,
    Input,
    Output,
} from '@angular/core';
import { IDialogButton } from '@dxp/core/models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'telxl-dialog-modal',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
    templateUrl: './dialog.component.html',
    styleUrl: './dialog.component.scss',
})
export class TelXLDialogModalComponent<T> {
    activeModal = inject(NgbActiveModal);

    @Input({ required: true }) title!: string;
    @Input({ required: true }) icon!: string;
    @Input({ required: true }) message!: string;
    @Input({ required: true }) buttons!: IDialogButton<T>[];

    @Output() dialogResult = new EventEmitter<T>();

    handleButtonClick(returnValue: T): void {
        this.dialogResult.emit(returnValue);
    }
}
